import AuditKendaraanArsipMain from "../../features/audit-kendaraan/audit-kendaraan-mobil/audit-kendaraan-mobil-arsip/component/AuditKendaraanArsipMain";

const AuditKendaraanArsipPage = () => {
  return <AuditKendaraanArsipMain />;
};

export default AuditKendaraanArsipPage;
